import { Box, Typography } from '@mui/material';
import React from 'react';
import { colors } from '../../theme';

function EmptyPageMessage() {
  return (
    <Box sx={{
      padding: 3,
    }}
    >
      <Box sx={{
        padding: 3,
        background: colors.grey['50'],
        borderRadius: '8px',
      }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            lineHeight: 1.25,
          }}
        >
          No treats right now, come sniff around later!
        </Typography>
        <Typography variant="caption">
          It can take a few weeks for the first insights to be generated. Fur-tunately good things are on the way!
        </Typography>
      </Box>
    </Box>
  );
}

export default EmptyPageMessage;
